module.exports = __webpack_public_path__ + "static/media/sports_icon.ad0c7856.svg";